 <div class="container-fluid webView" style="padding-left: 25px;padding-right: 25px;font-size: 15px;">
    <!-- Header WebView-->
    <div class="row" style="padding-top: 10px; margin: 0px;">
      <div class="col-md-12 col-sm-12 col-xs-12 pad0" style="padding: 0px">
        <div class="col-md-2 col-sm-2 col-xs-2"
          style="font-size: 30px; display: inline-block; vertical-align: bottom; padding-left: 0px;padding-right: 0px;">
          <h2 class="lblHeader newHeader" style="padding-right: 15px; display: inline-block;font-size: 30px;">Tasks</h2>
        </div>
        <div class="col-md-10 col-sm-2 col-xs-10"
          style="font-size: 30px; display: inline-block; vertical-align: bottom; text-align: right; padding: 0px; cursor: pointer;">
          <span (click)="redirectAllTaskReport()" class="btn btn-darkBlue middle brdrRadius3" *ngIf="checkAllTaskAccess()"
            title="Task Records" style="padding: 6px 5px 6px 5px; line-height: 0px; margin-right: 5px;">
            <i class="fa fa-list" style="vertical-align: middle;font-size: 12px;" aria-hidden="true"></i>
            <span style="font-size: 12px; margin-left: 3px;"> Task Records </span>
        </span>
          <span (click)="redirectTaskReport()" class="btn btn-darkBlue middle brdrRadius3" title="Tasks Report" style="padding: 6px 5px 6px 5px; line-height: 0px;">
            <i class="fa fa-line-chart" style="vertical-align: middle;font-size: 12px;" aria-hidden="true"></i>
        </span>
        </div>
      </div>
    </div>

    <div class="col-md-12 col-12 col-12" style="padding: 0px;margin-top: 15px;">
        <!-- Left WebView-->
        <!-- InBox WebView task for me-->
        <div class="col-12 col-md-6" style="display: inline-block;vertical-align: top;padding-right: 0px;padding-left: 0px;">
            <div class="mainCard shadow" style="border-radius: 3px;">
                <!-- Card Header WebView -->
                <div class="mainCardHeader">
                    <div class="col-md-2 col-xs-5 col-5" title="Tasks for Me" style="vertical-align: middle;display: inline-block;font-size: 20px;padding: 10px 10px 10px 15px;">
                        Inbox
                    </div>
                    <!--Body-->   
                    <div class="col-md-10 col-xs-7 col-7" style="display:inline-block; text-align: right;">  
                        <!--Month Select WebView-->
                        <div class="pad0" style="display: inline-block;padding: 0px 10px 5px 5px !important;" *ngIf="filterForMe == 2 || filterForMe == 3">           
                            <div style="display: inline-block;">
                                <label
                                    style="margin-left: 10px;margin-right: 5px; font-size: 14px; display: inline-block; margin-bottom:0px; font-weight: normal;"
                                    for="sel1">Month : </label>
                            </div>
                            <div style="display: inline-block;">
                                <select [(ngModel)]="view.month" (change) = "changeMonth()" class="form-control formCtlFltr" 
                                        style="display: inline-flex;width: 100%; cursor: pointer; margin-left: 5px; height: 28px !important;">
                                        <option *ngFor="let month of months"value="{{month.id}}">
                                                {{month.display}}
                                        </option>
                                </select>
                            </div>  
                        </div>
                        
                            <span class="greenText middle" title="Filter" (click)="openTaskFilter(tasksSearch)"
                                style="cursor: pointer; padding-left: 10px; line-height: 23px;font-size: 18px;vertical-align: sub;display: none;">
                                    <span><i class="fa fa-filter" aria-hidden="true"></i></span>
                            </span>
                            <span class="yellowText middle" title="Export to Excel"
                                style="cursor: pointer; padding-left: 10px; line-height: 23px;font-size: 18px; vertical-align: sub; display: none;"><span>
                                <i class="fa fa-file-excel-o" aria-hidden="true"></i></span>
                            </span>
                            <!--filters-->
                            <div *ngIf="!isShowTaskForMe" style="display: inline-block;">
                                <span (click)="tasksForMeFilter(0)" class="{{StatusID == 0 ? 'activeBtnOrange' : 'btn btn-orange'}} middle brdrRadius3" title="Pending" style="margin-left: 5px; padding: 4px 6px 4px 6px; line-height: 0px;">
                                    <i class="zmdi zmdi-time headerIcon" style="vertical-align: middle;font-size: 18px;" aria-hidden="true"></i>
                                </span>
    
                                <span (click)="tasksForMeFilter(1)" class="{{StatusID == 1 ? 'activeBtnOrange' : 'btn btn-orange'}} middle brdrRadius3" title="Paused" style="margin-left: 10px; padding: 4px 9px 4px 9px; line-height: 0px;">
                                    <i class="zmdi zmdi-pause headerIcon" style="vertical-align: middle;font-size: 18px;" aria-hidden="true"></i>
                                </span>
    
                                <span (click)="tasksForMeFilter(2)" class="{{StatusID == 2 ? 'activeBtnRed' : 'btn btn-red'}} middle brdrRadius3" title="Cancelled" style="margin-left: 10px; {{StatusID == 2 ? 'padding: 4px 6px !important' : 'padding: 0px 6px !important'}}; line-height: 0px;">
                                    <i class="zmdi zmdi-block-alt headerIcon" style="vertical-align: text-bottom; font-size: 18px;" aria-hidden="true"></i>
                                </span>
    
                                <span (click)="tasksForMeFilter(3)" class="{{StatusID == 3 ? 'activeBtnGreen' : 'btn btn-green'}} middle brdrRadius3" title="Done" style="margin-left: 10px; padding: 4px 7px 4px 7px; line-height: 0px;">
                                    <i class="zmdi zmdi-check headerIcon" style="vertical-align: middle;font-size: 18px;" aria-hidden="true"></i>
                                </span>
    
                                <!--Add Tasks For Me WebView-->
                                <span (click)="taskEntryModel(1)" class="btn btn-darkBlue middle brdrRadius3" title="Add Task" style="margin-left: 10px; padding: 4px 8px 4px 8px; line-height: 0px;">
                                    <i class="zmdi zmdi-plus headerIcon" style="vertical-align: middle;font-size: 18px;" aria-hidden="true"></i>
                                </span>
                            </div>
                        
                            <div style="display: inline-block;">
                                <div *ngIf="isShowTaskForMe" style="display: {{isShowTaskForMe ? 'inline-block' : 'none'}}; width: 120px;">
                                    <input type="text" [(ngModel)]="search"
                                        class="form-control font13 wdth" style="display: inline-block;" autofocus />
                                </div>
                                <span class="btn btn-darkBlue middle brdrRadius3" (click)="clearSearch()" style="margin-left: 10px; padding: {{isShowTaskForMe ? '4px 8px 4px 8px' : '4px 7px 4px 7px'}}; line-height: 0px;"(click)="isShowTaskForMe = !isShowTaskForMe" >
                                    <i class="zmdi zmdi-search headerIcon" aria-hidden="true" *ngIf="!isShowTaskForMe" style="vertical-align: middle;font-size: 18px;" title="Search"></i>
                                    <i class="zmdi zmdi-close headerIcon" aria-hidden="true" *ngIf="isShowTaskForMe" style="vertical-align: middle;font-size: 18px;" title="Close"></i>
                                </span>
                              </div>
                    </div>
                     
                    <!--List view WebView for me-->
                    <div  class="hgtDiv" style="display: list-item;width:100%;">
                    <div style="padding: 0px;margin-top: 10px;" *ngIf="tskData.length > 0">
                        <div class="col-md-12 col-xs-12 col-sm-12" (click)="openTaskDetails(l)"
                            *ngFor="let l of tskData |filter:'Task,Detail,CreatedUserName':search, let i = index" style="padding: 0px; cursor: pointer; background-color: {{ i % 2 == 0 ? '#f5f5f5': 'white'}}">           
                                <div style="padding: 8px 0px 0px;">
                                    <div class="col-md-9 col-sm-7 col-xs-7" style="display: inline-block; vertical-align: top; padding-right: 0px;">
                                        <div>
                                            <span class="list-title fnsize longName" style="vertical-align: top; margin-right: 5px; font-size: 12px;">{{l.Task}}
                                                <span style="color: #999;" title="#{{l.TaskID}}">(#{{l.TaskID}})</span>
                                            </span>
                                        </div>
                                        <div style="margin-top: 5px;">
                                            <p style="color: #999;font-size: 12px;margin: 0px;top: 0px;width: 100%; display: inline-block; text-overflow: ellipsis; white-space: nowrap;overflow: hidden;" title="">{{l.Detail ? l.Detail : ''}}</p> 
                                        </div>
                                    </div>
                                    <div class="col-md-3 col-sm-5 col-xs-5" style="text-align : right;display: inline-block; vertical-align: top; padding-left: 0px;">                    
                                        <!-- Priority Arrow -->
                                        <span class="orangeText" *ngIf="l.Priority != 1" style="margin-right: 5px;" title="{{l.Priority == 2 ? 'Low Priority' : 'High Priority'}}">
                                            <i class="zmdi {{(l.Priority == 0 ? 'zmdi-long-arrow-up' : (l.Priority == 2 ? 'zmdi-long-arrow-down' : ''))}} "></i>
                                        </span>

                                        <!-- Exp. Completion Date -->
                                        <div class="mrg0 biziBadge {{l.color}} fnsize brdrRadius3" style="display: inline-block;font-size: 12px;" title="{{filterForMe == 2 || filterForMe == 3  ? 'Completed' : 'Target'}}">
                                            <span>
                                                <i class="fa fa-calendar" style="padding-right: 5px;"></i> 
                                                {{((filterForMe == 2 || filterForMe == 3) ? l.DoneDT : l.ExpCompletionDT) | todayTommorow}}
                                            </span>
                                        </div>   
                                        <!--Task Assign Name-->
                                        <div>
                                            <span class="" style="display: inline-block;color: #999;font-size: 12px;" title="{{l.ToUserName}}">{{l.CreatedUserName}}</span>            
                                        </div>                             
                                    </div>
                                </div>
                                <div style="display: none;">
                                    <div class="col-md-8 col-sm-7 col-xs-7" style="display: inline-block;">
                                        <div >
                                            <div class="fnsize" style="margin-right: 5px; margin-bottom: 5px; display: inline-block; border: 1px solid #ddd; padding: 2px 15px; border-radius: 25px; background:rgb(31 98 142 / 10%) !important; color:#15304a"
                                                *ngFor="let x of l.Tags; let i = index">
                                                <span>
                                                    {{x}}
                                                </span>
                                            </div>                                      
                                        </div>
                                    </div> 
                                    <div class="col-md-4 col-sm-5 col-xs-5" style="text-align : right; padding-right: 7px;display: inline-block; position: absolute;">                    
                                        <div class="mrg0 fontSizeHead" style="color: #333 !important; cursor: default;top: 5px;position: relative;">   
                                            <span>
                                                <span class="ng-binding fnsize" style="margin-right: 5px;">{{l.TaskID}}</span>
                                            </span>
                                        </div> 
                                    </div>             
                                </div>
                        </div>
                    </div>
                    <div *ngIf="((tskData | filter:'Task,Detail':search).length === 0) && (tskData.length != 0)">
                        <span class="nrf brdrRadius3" style="margin: 10px 15px;">No task found.</span>
                    </div>
                    <div class="col-md-12" *ngIf="tskData.length == 0">
                        <span (click)="taskEntryModel(1)" class="nrf brdrRadius3" style="margin: 10px 0px; cursor: pointer;">
                            Click here to create a task.
                        </span>
                    </div>
                    </div>
              </div>
            </div>
        </div>

        <!-- Right WebView-->
        <!-- Outbox WebView task for others-->
        <div class="col-12 col-md-6" style="display: inline-block;vertical-align: top;padding-right: 0px;">
            <div class="mainCard shadow" style="border-radius: 3px;">
                <!-- Card Header WebView task for others-->
                <div class="mainCardHeader">
                    <div class="col-md-2 col-xs-5 col-5" style="vertical-align: middle;display: inline-block;font-size: 20px;padding: 10px 10px 10px 15px;" title="Tasks for Others">
                        <span>Outbox</span>
                    </div>  
                     <!--Body task for others-->      
                    <div class="col-md-10 col-xs-7 col-7" style="display:inline-block; text-align: right;">  
                        <!--Month Select WebView task for others-->
                    <div class="pad0"  *ngIf="filterDelegated == 2 || filterDelegated == 3" style="display: inline-block;padding: 0px 10px 5px 5px !important;">           
                        <div style="display: inline-block;">
                            <label
                                style="margin-left: 10px;margin-right: 5px; font-size: 14px; display: inline-block; margin-bottom:0px; font-weight: normal;"
                                for="sel1">Month : </label>
                        </div>
                        <div style="display: inline-block;">
                            <select [(ngModel)]="view.delegateMnth" (change) = "changeDelegateMonth()" class="form-control formCtlFltr" 
                                    style="display: inline-flex;width: 100%; cursor: pointer; margin-left: 5px; height: 28px !important;">
                                    <option *ngFor="let month of months"value="{{month.id}}">
                                            {{month.display}}
                                    </option>
                            </select>
                        </div>  
                    </div>

                         <!--filters-->
                         <div *ngIf="!isShowDelegatedForMe" style="display: inline-block;">
                            <span (click)="delegatedTasksFilter(0)" class="{{delegateStatusID == 0 ? 'activeBtnOrange' : 'btn btn-orange'}} middle brdrRadius3" title="Pending" style="margin-left: 5px; padding: 4px 6px 4px 6px; line-height: 0px;">
                                <i class="zmdi zmdi-time headerIcon" style="vertical-align: middle;font-size: 18px;" aria-hidden="true"></i>
                            </span>

                            <span (click)="delegatedTasksFilter(1)" class="{{delegateStatusID == 1 ? 'activeBtnOrange' : 'btn btn-orange'}} middle brdrRadius3" title="Paused" style="margin-left: 10px; padding: 4px 9px 4px 9px; line-height: 0px;">
                                <i class="zmdi zmdi-pause headerIcon" style="vertical-align: middle;font-size: 18px;" aria-hidden="true"></i>
                            </span>

                            <span (click)="delegatedTasksFilter(2)" class="{{delegateStatusID == 2 ? 'activeBtnRed' : 'btn btn-red'}} middle brdrRadius3" title="Cancelled" style="margin-left: 10px; {{delegateStatusID == 2 ? 'padding: 4px 6px !important' : 'padding: 0px 6px !important'}}; line-height: 0px;">
                                <i class="zmdi zmdi-block-alt headerIcon" style="vertical-align: text-bottom; font-size: 18px;" aria-hidden="true"></i>
                            </span>

                            <span (click)="delegatedTasksFilter(3)" class="{{delegateStatusID == 3 ? 'activeBtnGreen' : 'btn btn-green'}} middle brdrRadius3" title="Done" style="margin-left: 10px; padding: 4px 7px 4px 7px; line-height: 0px;">
                                <i class="zmdi zmdi-check headerIcon" style="vertical-align: middle;font-size: 18px;" aria-hidden="true"></i>
                            </span>

                            <!--Add Tasks For others WebView-->
                            <span (click)="taskEntryModel(2)" class="btn btn-darkBlue middle brdrRadius3" title="Add Task" style="margin-left: 10px; padding: 4px 8px 4px 8px; line-height: 0px;">
                                <i class="zmdi zmdi-plus headerIcon" style="vertical-align: middle;font-size: 18px;" aria-hidden="true"></i>
                            </span>
                        </div>
            
                        <div style="display: inline-block;">
                            <div *ngIf="isShowDelegatedForMe"  style="display: {{isShowDelegatedForMe ? 'inline-block' : 'none'}}; width: 120px;">
                                <input type="text" [(ngModel)]="searchdelegated"
                                    class="form-control font13 wdth" style="display: inline-block;height: 24px;" autofocus />
                            </div>
                            <span class="btn btn-darkBlue middle brdrRadius3" (click)="clearSearchForDele()" style="margin-left: 10px; padding: {{isShowDelegatedForMe ? '4px 8px 4px 8px' : '4px 7px 4px 7px'}};line-height: 0px;"(click)="isShowDelegatedForMe = !isShowDelegatedForMe" title="Search">
                                <i class="zmdi zmdi-search headerIcon" aria-hidden="true" *ngIf="!isShowDelegatedForMe" style="vertical-align: middle;font-size: 18px;" title="Search"></i>
                                <i class="zmdi zmdi-close headerIcon" aria-hidden="true" *ngIf="isShowDelegatedForMe" style="vertical-align: middle;font-size: 18px;" title="Close"></i>
                            </span>
                        </div>
                    </div>
                    
                    <!--List view WebView task for others-->
                    <div  class="hgtDiv" style="display: list-item;width:100%;">
                        <div style="padding: 0px;margin-top: 10px;" *ngIf="tskDlgtData.length > 0"> 
                
                            <div class="col-md-12 col-xs-12 col-sm-12" (click)="openTaskDetails(dl)"
                                *ngFor="let dl of tskDlgtData | filter:'Task,Detail,ToUserName':searchdelegated, let i = index"
                                        style="padding: 0px; cursor: pointer; background-color: {{ i % 2 == 0 ? '#f5f5f5': 'white'}}">
                                <div style="padding: 8px 0px 0px;">
                                    <div class="col-md-8 col-sm-7 col-xs-7" style="display: inline-block; vertical-align: top; padding-right: 0px;">
                                            <div>
                                               <span class="list-title longName fnsize" style="vertical-align: top;margin-right: 5px; font-size: 12px;">{{dl.Task}}
                                                    <span style="color: #999;" title="#{{dl.TaskID}}">(#{{dl.TaskID}})</span> 
                                                </span>        
                                            </div>
                                            <div style="margin-top: 5px;">
                                                <p style="color: #999;font-size: 12px; margin: 0px;top: 0px;width: 100%; display: inline-block; text-overflow: ellipsis; white-space: nowrap;overflow: hidden;" title="">{{dl.StatusNote ? dl.StatusNote : ''}}</p>
                                            </div>
                                    </div>
                                    <div class="col-md-4 col-sm-5 col-xs-5" style="text-align: right; display: inline-block; vertical-align: top; padding-left: 0px;">                     
                                       <!-- Remider -->
                                       <span class="remider brdrRadius3" title="Send Reminder" *ngIf="delegateStatusID == 0" (click)="sendReminder(dl); $event.stopPropagation()">
                                            <i class="fa fa-bell"></i>
                                       </span>
                                        <!-- Priority Arrow -->
                                        <span class="orangeText" *ngIf="dl.Priority != 1" style="margin-right: 5px;" title="{{dl.Priority == 2 ? 'Low Priority' : 'High Priority'}}">
                                            <i class="zmdi {{(dl.Priority == 0 ? 'zmdi-long-arrow-up' : (dl.Priority == 2 ? 'zmdi-long-arrow-down' : ''))}} "></i>
                                        </span>

                                        <!-- Exp. Completion Date -->
                                        <div class="mrg0 biziBadge {{dl.color}} brdrRadius3" style="display: inline-block;font-size: 12px;" title="{{filterDelegated == 2 || filterDelegated == 3  ? 'Completed' : 'Target'}}">
                                            <span>
                                                <i class="fa fa-calendar" style="padding-right: 5px;"></i> 
                                                {{((filterDelegated == 2 || filterDelegated == 3) ? dl.DoneDT : dl.ExpCompletionDT) | todayTommorow}}
                                            </span>
                                        </div>
                                        <!--Task Assign Name-->
                                        <div>
                                            <span class="" style="display: inline-block;color: #999;font-size: 12px;" title="{{dl.ToUserName}}">{{dl.ToUserName}}</span>            
                                        </div> 
                                    </div>
                                </div>
                                <div style="display: none;">  
                                    <div class="col-md-8 col-sm-7 col-xs-7" style="display: inline-block;">
                                        <div *ngIf="dl.Tags.length > 0">
                                            <div class="fnsize" style="margin-right: 5px; margin-bottom: 5px; display: inline-block; border: 1px solid #ddd; padding: 2px 15px; border-radius: 25px; background:rgb(31 98 142 / 10%) !important; color:#15304a"
                                                *ngFor="let x of dl.Tags; let i = index">
                                                <span>
                                                    {{x}}
                                                </span>
                                            </div>                                      
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-sm-5 col-xs-5" style="text-align : right; padding-right: 7px;display: inline-block;position: absolute;"> 
                                        <div class="mrg0 fontSizeHead fnsize" style="color: #333 !important; cursor: default;top: 5px;position: relative;">   
                                            <span>
                                                <span class="ng-binding" style="margin-right: 5px;">{{dl.TaskID}}</span>                       
                                            </span>
                                        </div> 
                                    </div>                                 
                                </div>  
                            </div>
                        </div>
                        <div *ngIf="((tskDlgtData | filter:'Task,Detail':searchdelegated).length === 0) && (tskDlgtData.length != 0)">
                            <span class="nrf brdrRadius3" style="margin: 10px 15px;">No task found.</span>
                        </div>
        
                        <div class="col-md-12" *ngIf="tskDlgtData.length == 0">
                            <span (click)="taskEntryModel(2)" class="nrf brdrRadius3" style="margin: 10px 0px; cursor: pointer;">
                                Click here to create a task.
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Mobile view -->
<div class="container-fluid mobView" style="font-size: 15px;padding: 0px;">
    <!-- Inbox -->
    <div *ngIf="isInboxShow == true" class="col-12 col-sm-12 col-xs-12" style="padding: 0px;">
        <div class="col-12 col-sm-12 col-xs-12" style="padding: 15px;">
            <div class="col-6 col-sm-6 col-xs-6" style="font-size: 30px;padding: 0px;display: inline-block; vertical-align: middle;">
                <h2 style="margin: 0px;" class="newHeader">Inbox</h2>
            </div>
            <div class="col-6 col-sm-6 col-xs-6" style="padding: 0px; display: inline-block;text-align: right; vertical-align:top;">
                <!-- <span (click)="backToHomeBtn()" style="float:right;">
                    <i class="fa fa-bars" style="font-size: 20px;"></i>
                </span> -->
                <span class="btn darkBlueButton" (click)="backToHomeBtn()"><i class="zmdi zmdi-arrow-left" style="margin-right: 5px;"></i>Back
                </span>
            </div>
        </div>

        <!-- filters -->
        <div *ngIf="!isShowTaskForMe" class="col-md-12 col-sm-12 col-xs-12" style="margin-bottom: 15px;">
            <span (click)="tasksForMeFilter(0)" class="{{StatusID == 0 ? 'activeBtnYellow' : 'btn btn-yellow'}} middle brdrRadius3" title="Pending" style="padding: 4px 6px 4px 6px; line-height: 0px;">
                <i class="zmdi zmdi-time headerIcon" style="vertical-align: middle;font-size: 18px;" aria-hidden="true"></i>
            </span>

            <span (click)="tasksForMeFilter(1)" class="{{StatusID == 1 ? 'activeBtnOrange' : 'btn btn-orange'}} middle brdrRadius3" title="Paused" style="margin-left: 10px; padding: 4px 9px 4px 9px; line-height: 0px;">
                <i class="zmdi zmdi-pause headerIcon" style="vertical-align: middle;font-size: 18px;" aria-hidden="true"></i>
            </span>

            <span (click)="tasksForMeFilter(2)" class="{{StatusID == 2 ? 'activeBtnRed' : 'btn btn-red'}} middle brdrRadius3" title="Cancelled" style="margin-left: 10px; {{delegateStatusID == 2 ? 'padding: 4px 6px !important' : 'padding: 3px 6px !important'}}; line-height: 0px !important;">
                <i class="zmdi zmdi-block-alt headerIcon" style="vertical-align: middle;font-size: 18px;" aria-hidden="true"></i>
            </span>

            <span (click)="tasksForMeFilter(3)" class="{{StatusID == 3 ? 'activeBtnGreen' : 'btn btn-green'}} middle brdrRadius3" title="Done" style="margin-left: 10px; padding: 4px 7px 4px 7px; line-height: 0px;">
                <i class="zmdi zmdi-check headerIcon" style="vertical-align: middle;font-size: 18px;" aria-hidden="true"></i>
            </span>
            <!-- <div style="float: right;" *ngIf="filterForMe == 2 || filterForMe == 3">           
                <div style="display: inline-block;">
                    <label
                        style="margin-left: 10px;margin-right: 5px; font-size: 14px; display: inline-block; margin-bottom:0px; font-weight: normal;"
                        for="sel1">Month : </label>
                </div>
                <div style="display: inline-block;">
                    <select [(ngModel)]="view.month" (change) = "changeMonth()" class="form-control" 
                                    style="display: inline-flex;width: 100%; cursor: pointer;">
                                    <option *ngFor="let month of months"value="{{month.id}}">
                                            {{month.display}}
                                    </option>
                            </select>
                </div>          
            </div> -->
        </div>
        <div class="col-md-12 col-sm-12 col-xs-12" style="display: inline-block;padding-bottom: 15px;" *ngIf="filterForMe == 2 || filterForMe == 3">           
                <div style="display: inline-block;">
                    <label
                        style="margin-right: 5px; font-size: 14px; display: inline-block; margin-bottom:0px; font-weight: normal;"
                        for="sel1">Month : </label>
                </div>
                <div style="display: inline-block;">
                    <select [(ngModel)]="view.month" (change) = "changeMonth()" class="form-control formCtlFltr brdrRadius3" 
                                    style="display: inline-flex;width: 100%; cursor: pointer;">
                                    <option *ngFor="let month of months"value="{{month.id}}">
                                            {{month.display}}
                                    </option>
                    </select>
                </div>          
        </div>
        <div class="col-md-12 col-12 col-sm-12" style="margin-bottom: 15px;">
            <div class="input-icons search">
                <span class="fa fa-search" style="top: 10px !important;"></span>
                <input class="form-control formCtlFltr brdrRadius3" [(ngModel)]="search" placeholder="Search"style="text-indent: 15px; padding: 18px; box-shadow: none; width: 75%; float: left;"type="text">
                <span>
                    <span (click)="taskEntryModel(1)" class="label darkBlueBadge brdrRadius3"style="top: 1px; cursor: pointer; margin-left: 14px; position: relative; bottom: 5px; padding: 3px 12px 10px 12px; font-size: 11px; background: #e88421 !important; color: #fff !important">
                        <i class="zmdi zmdi-plus" aria-hidden="true" style="position: relative; top: 4px; font-size: 22px"></i>
                    </span>
                </span>
            </div>
        </div>

        <div  class="{{(filterForMe == 0 || filterForMe == 1) ? 'hgtDiv' : 'hgtDiv1'}}" style="display: list-item;width:100%;">
            <div style="padding: 0px;margin-top: 10px;" *ngIf="tskData.length > 0">
                <div class="col-12 col-xs-12 col-sm-12" (click)="openTaskDetails(l)"
                    *ngFor="let l of tskData| filter:'Task,Detail,ToUserName':search, let i = index" style="cursor: pointer; background-color: {{ i % 2 == 0 ? '#f5f5f5': 'white'}}; padding: {{isGalaxyFoldMobile ? '0 5px' : '0 15px'}};">              
                    <div style="padding-top: 10px;">                        
                        <div class="col-7 col-sm-8 col-xs-8" style="display: inline-block;padding: 0px;">
                            <span class="list-title longNameMob fnsize" style="margin-right: 5px;"> {{l.Task}} </span>   
                            <span style="color: #999;font-size: 12px;vertical-align: top;" title="#{{l.TaskID}}">(#{{l.TaskID}})</span>                                   
                        </div>
                        <div class="col-5 col-sm-4 col-xs-4" style="text-align : right; display: inline-block; padding: 0px; top: -5px;" title="Target">                    
                            <!-- Priority Arrow -->
                            <span class="{{l.Priority == 0 ? 'orangeText' : 'blueText'}}" *ngIf="l.Priority != 1" style="margin-right: 10px; vertical-align: text-bottom;" title="{{l.Priority == 2 ? 'Low Priority' : 'High Priority'}}">
                                <i class="zmdi {{(l.Priority == 0 ? 'zmdi-long-arrow-up' : (l.Priority == 2 ? 'zmdi-long-arrow-down' : ''))}} "></i>
                            </span>

                            <div class="mrg0 {{l.color}} fnsize" style="display: inline-block;vertical-align: text-bottom;">
                                <span>
                                    <i class="fa fa-calendar"></i> {{l.ExpCompletionDT | todayTommorow }}
                                </span>
                            </div>     
                        </div>
                        <div class="col-12 col-sm-12 col-xs-12" style="display: inline-block;padding: 0px;">
                            <p style="color: #aeaeae;font-size: 13px;margin: 0px;top: 0px;width: 72%; display: inline-block; text-overflow: ellipsis; white-space: nowrap; overflow: hidden;" title="">{{l.Detail ? l.Detail : ''}}</p>
                            <!--Task Assign Name-->
                            <span style="width: 27%; display: inline-block; color: #999;font-size: 12px; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; text-align: right;" title="{{l.ToUserName}}">{{l.CreatedUserName}}</span>             
                        </div>
                    </div>                    
                </div>
            </div>

            <div *ngIf="((tskData | filter:'Task,Detail':search).length === 0) && (tskData.length != 0)">
                <span class="nrf" style="margin: 10px 15px;">No task found!</span>
            </div>

            <div class="col-md-12" *ngIf="tskData.length == 0">
                <span (click)="taskEntryModel(1)" class="nrf" style="margin: 10px 0px; cursor: pointer;">
                    Click here to create task.
                </span>
            </div>

        </div>
    </div>

    <!-- Outbox -->
    <div *ngIf="isOutbox == true" class="col-12 col-sm-12 col-xs-12" style="padding: 0px;">
        <div class="col-12 col-sm-12 col-xs-12" style="padding: 15px;">
            <div class="col-6 col-sm-6 col-xs-6" style="font-size: 30px;padding: 0px;display: inline-block;  vertical-align: middle;">
                <h2 style="margin: 0px;" class="newHeader">Outbox</h2>
            </div>
            <div  class="col-6 col-sm-6 col-xs-6" style="padding: 0px; display: inline-block;text-align: right; vertical-align: top;">                
                <!-- <span (click)="backToHomeBtn()" style="float:right;">
                    <i class="fa fa-bars" style="font-size: 20px;"></i>
                </span> -->
                <span class="btn darkBlueButton" (click)="backToHomeBtn()"><i class="zmdi zmdi-arrow-left" style="margin-right: 5px;"></i>Back
                </span>
            </div>
        </div>

        <!-- filters -->
        <div *ngIf="!isShowTaskForMe" class="col-md-12 col-sm-12 col-xs-12" style="margin-bottom: 15px;">
            <span (click)="delegatedTasksFilter(0)" class="{{delegateStatusID == 0 ? 'activeBtnYellow' : 'btn btn-yellow'}} middle brdrRadius3" title="Pending" style="margin-right: 10px; padding: 4px 6px 4px 6px; line-height: 0px;">
                <i class="zmdi zmdi-time headerIcon" style="vertical-align: middle;font-size: 18px;" aria-hidden="true"></i>
            </span>

            <span (click)="delegatedTasksFilter(1)" class="{{delegateStatusID == 1 ? 'activeBtnOrange' : 'btn btn-orange'}} middle brdrRadius3" title="Paused" style="margin-right: 10px; padding: 4px 9px 4px 9px; line-height: 0px;">
                <i class="zmdi zmdi-pause headerIcon" style="vertical-align: middle;font-size: 18px;" aria-hidden="true"></i>
            </span>

            <span (click)="delegatedTasksFilter(2)" class="{{delegateStatusID == 2 ? 'activeBtnRed' : 'btn btn-red'}} middle brdrRadius3" title="Cancelled" style="margin-right: 10px; padding: 4px 6px 4px 6px !important; line-height: 0px !important;">
                <i class="zmdi zmdi-block-alt headerIcon" style="vertical-align: middle;font-size: 18px;" aria-hidden="true"></i>
            </span>

            <span (click)="delegatedTasksFilter(3)" class="{{delegateStatusID == 3 ? 'activeBtnGreen' : 'btn btn-green'}} middle brdrRadius3" title="Done" style="margin-right: 10px; padding: 4px 7px 4px 7px; line-height: 0px;">
                <i class="zmdi zmdi-check headerIcon" style="vertical-align: middle;font-size: 18px;" aria-hidden="true"></i>
            </span>
            <!-- <div style="float: right;" *ngIf="filterDelegated == 2 || filterDelegated == 3">           
                <div style="display: inline-block;">
                    <label
                        style="margin-left: 10px;margin-right: 5px; font-size: 14px; display: inline-block; margin-bottom:0px; font-weight: normal;"
                        for="sel1">Month : </label>
                </div>
                <div style="display: inline-block;">
                    <select [(ngModel)]="view.delegateMnth" (change) = "changeDelegateMonth()" class="form-control" 
                                    style="display: inline-flex;width: 100%; cursor: pointer;">
                                    <option *ngFor="let month of months"value="{{month.id}}">
                                            {{month.display}}
                                    </option>
                            </select>
                </div>          
            </div> -->
        </div>
        <div class="col-md-12 col-12 col-sm-12" style="display: inline-block;padding-bottom: 15px;" *ngIf="filterDelegated == 2 || filterDelegated == 3">           
            <div style="display: inline-block;">
                <label
                    style="margin-left: 10px;margin-right: 5px; font-size: 14px; display: inline-block; margin-bottom:0px; font-weight: normal;"
                    for="sel1">Month : </label>
            </div>
            <div style="display: inline-block;">
                <select [(ngModel)]="view.delegateMnth" (change) = "changeDelegateMonth()" class="form-control" 
                                style="display: inline-flex;width: 100%; cursor: pointer;">
                                <option *ngFor="let month of months"value="{{month.id}}">
                                        {{month.display}}
                                </option>
                        </select>
            </div>          
        </div>

        <div class="col-md-12 col-12 col-sm-12" style="margin-bottom: 15px;">
            <div class="input-icons search">
                <span class="fa fa-search" style="top: 10px !important;"></span>
                <input class="form-control formCtlFltr brdrRadius3" [(ngModel)]="searchdelegated" placeholder="Search"style="text-indent: 15px; padding: 18px; box-shadow: none; width: 75%; float: left;"type="text">
                <span>
                    <span (click)="taskEntryModel(2)" class="label darkBlueBadge brdrRadius3"style="top: 1px; cursor: pointer; margin-left: 14px; position: relative; bottom: 5px; padding: 3px 12px 10px 12px; font-size: 11px; background: #e88421 !important; color: #fff !important">
                        <i class="zmdi zmdi-plus" aria-hidden="true" style="position: relative; top: 4px; font-size: 22px"></i>
                    </span>
                </span>
            </div>
        </div>

        <div class="{{(filterDelegated == 0 || filterDelegated == 1) ? 'hgtDiv' : 'hgtDiv1'}}" style="display: list-item;width:100%;">
            <div style="padding: 0px;margin-top: 10px;" *ngIf="tskDlgtData.length > 0">
                <div class="col-12 col-xs-12 col-sm-12" (click)="openTaskDetails(dl)" 
                    *ngFor="let dl of tskDlgtData | filter:'Task,Detail,ToUserName':searchdelegated, let i = index" 
                    style="cursor: pointer; background-color: {{ i % 2 == 0 ? '#f5f5f5': 'white'}}; padding: {{isGalaxyFoldMobile ? '0 5px;' : '0 15px;'}};">              
                    <div style="padding-top: 10px;">                        
                        <div class="{{isGalaxyFoldMobile ? 'col-6' : 'col-7'}} col-sm-5 col-xs-5" style="display: inline-block;padding: 0px;">
                            <span class="list-title longNameMob fnsize" style="max-width: {{isGalaxyFoldMobile ? '50% !important;' : '75% !important;'}}">{{dl.Task}}</span>  
                            <span style="color: #999;font-size: 12px;vertical-align: top;" title="#{{dl.TaskID}}">(#{{dl.TaskID}})</span>                                       
                        </div>
                        <div class="{{isGalaxyFoldMobile ? 'col-6' : 'col-5'}} col-sm-7 col-xs-7" style="text-align : right; display: inline-block; padding: 0px; top: -4px;" title="Target">                    
                           <!-- Remider -->
                           <span class="remider" title="Send Reminder" *ngIf="delegateStatusID == 0" (click)="sendReminder(dl); $event.stopPropagation()" style="position: relative; top: -2px; margin-right: {{isGalaxyFoldMobile ? '7px !important' : '10px'}};">
                                <i class="fa fa-bell"></i>
                            </span>
                            <!-- Priority Arrow -->
                            <span class="{{dl.Priority == 0 ? 'orangeText' : 'blueText'}}" *ngIf="dl.Priority != 1" style="margin-right: 10px; position: relative; top: -2px;" title="{{dl.Priority == 2 ? 'Low Priority' : 'High Priority'}}">
                                <i class="zmdi {{(dl.Priority == 0 ? 'zmdi-long-arrow-up' : (dl.Priority == 2 ? 'zmdi-long-arrow-down' : ''))}} "></i>
                            </span>

                            <div class="mrg0 {{dl.color}} fnsize" style="display: inline-block;vertical-align: text-bottom;">
                                <span>
                                    <i class="fa fa-calendar"></i> {{dl.ExpCompletionDT | todayTommorow }}
                                </span>
                            </div>    
                                                    
                        </div>
                        <div class="col-12 col-sm-12 col-xs-12" style="display: inline-block;padding: 0px;">
                            <p style="color: #aeaeae;font-size: 13px;margin: 0px;top: 0px;width: 70%; display: inline-block; text-overflow: ellipsis; white-space: nowrap;overflow: hidden;" title="">{{dl.StatusNote ? dl.StatusNote : ''}}</p>
                            <!--Task Assign Name-->
                                <span style="width: 30%;display: inline-block;color: #999;font-size: 12px;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;text-align: right;" title="{{dl.ToUserName}}">{{dl.ToUserName}}</span>             
                        </div>   
                    </div>                    
                </div>
            </div>
            
            <!-- <div style="padding: 0px;margin-top: 10px;" *ngIf="tskDlgtData.length > 0">      
                <div class="col-12 col-xs-12 col-sm-12" (click)="openTaskDetails(dl)"*ngFor="let dl of tskDlgtData | filter:'Task,Detail':searchdelegated, let i = index" style="cursor: pointer; background-color: {{ i % 2 == 0 ? '#f5f5f5': 'white'}}">
                    <div style="padding-top: 10px;">           
                        <div class="col-6 col-sm-6 col-xs-6" style="display: inline-block; padding: 0px;">
                            <div class="list-title fnsize">
                                {{dl.Task}}
                            </div>         
                        </div>
                        <div class="col-6 col-sm-6 col-xs-6" style="text-align : right;display: inline-block;">                     
                            <div class="mrg0 biziBadge {{dl.color}}" style="display: inline-block;" title="Target">
                                <span>
                                    <i class="fa fa-calendar" style="padding-right: 5px;"></i> {{dl.ExpCompletionDT | todayTommorow }}
                                </span>
                            </div>
                        </div>
                        <div class="col-12 col-sm-12 col-xs-12" style="display: inline-block; padding: 0px;">
                            <p style="color: #aeaeae;font-size: 13px;margin: 0px;top: 0px;width: 60%; display: inline-block; text-overflow: ellipsis; white-space: nowrap;overflow: hidden;" title="">{{dl.Detail ? dl.Detail : '-'}}</p>
                        </div>
                    </div>                     
                </div>
            
            </div> -->
            <div *ngIf="((tskDlgtData | filter:'Task,Detail':searchdelegated).length === 0) && (tskDlgtData.length != 0)">
                <span class="nrf" style="margin: 10px 15px;">No task found!</span>
            </div>

            <div class="col-md-12" *ngIf="tskDlgtData.length == 0">
                <span (click)="taskEntryModel(2)" class="nrf brdrRadius3" style="margin: 10px 0px; cursor: pointer;">
                    Click here to create task.
                </span>
            </div>
        </div>
    </div>
</div>

<!-- Training Materials -->
<div class="webView" style="margin-top: -75px; margin-left: 25px;">
    <a href="https://biziverse.com/support/support.html?abt=tasks" target="_blank" class="trngDarkBlueBtn" 
        style="padding: 4px 10px; display: inline-block; line-height: 1.66em; text-decoration: none;">
        <i class="zmdi zmdi-help-outline" style="margin-right: 5px; font-size: 16px; vertical-align: middle;"></i> Training Materials
    </a>
    <span *ngIf="!showLearningMaterial && showOnBoarding" (click)="openHelpPage(15)" class="trngDarkBlueBtn" style="margin-left: 10px;">
        <i class="fa fa-question" style="margin-right: 5px; vertical-align: initial; font-size: 16px;"></i> Need Help
    </span>
    <span (click)="openTrngModal()" class="trngDarkBlueBtn" style="margin-left: 10px;">
        <i class="fa fa-youtube-play" style="margin-right: 5px; vertical-align: initial; font-size: 16px;"></i> Watch Training
      </span>
</div>

<div class="mobView" style="margin-top: -40px; margin-left: 10px !important;">
    <a href="https://biziverse.com/support/support.html?abt=tasks" target="_blank" class="trngDarkBlueBtn brdrRadius3" 
        style="padding: 4px 10px; display: inline-block; line-height: 1.66em; text-decoration: none;">
        <i class="zmdi zmdi-help-outline" style="margin-right: 5px; font-size: 16px; vertical-align: inherit;"></i> Training Materials
    </a>
    <span *ngIf="!showLearningMaterial && showOnBoarding" (click)="openHelpPage(15)" class="trngDarkBlueBtn" style="margin-left: 10px;">
        <i class="fa fa-question" style="margin-right: 5px; vertical-align: initial; font-size: 16px;"></i> Need Help
    </span>
    <span (click)="openTrngModal()" class="trngDarkBlueBtn" style="margin-left: 10px;">
        <i class="fa fa-youtube-play" style="margin-right: 5px; vertical-align: initial; font-size: 16px;"></i> Watch Training
      </span>
</div>

<!-- Tasks search -->
<ng-template #tasksSearch let-modal>
 <!--Header-->
 <div class="col-md-12 col-sm-12 col-12">
    <div class="row">
      <div class="col-md-9 col-sm-10 col-10" style="padding: 15px; padding-bottom: 0px;">
        <h4> Filter</h4>
      </div>
      <div class="col-md-3 col-sm-2 col-2" style="padding: 15px; padding-bottom: 0px;">
        <i class="closeMdl zmdi zmdi-close" style="float: right;" (click)="closeModel()"></i>
      </div>
    </div>
  </div>

  <!--Body-->
  <div class="modal-body">
    <div class="col-md-12 col-sm-12 col-12" style="padding-left: 0px;">
      <div class="col-md-12 col-sm-12 col-12" style="padding: 0px; margin-bottom: 10px;">

          <!--search for Tag List -->
          <select style="width: 96%; margin-top: 10px;" class="form-control">
                    <option [value]="0">Select tags</option>
                    <option *ngFor="let t of tagList" [value]="t.id"> {{t.tag}}</option>          
          </select>

          <!--search for me-->
          <select style="width: 96%; margin-top: 10px;" class="form-control">
                        <option [value]="0">Select Assigned By</option>
                        <option [value]="1">sahil patel </option>
                        <option [value]="2">Jaymn Panchal </option>
                        <option [value]="3">Select </option>
          </select>

          <!--search for Deleated-->
          <select style="width: 96%; margin-top: 10px;" class="form-control">
                        <option [value]="0">Select Assigned To</option>
                        <option [value]="1">sahil patel </option>
                        <option [value]="2">Jaymn Panchal </option>
                        <option [value]="3">Select </option>      
          </select>

      </div>
    </div>
  </div>
  <!--Footer-->
  <div class="" style="padding: 15px; border: none; text-align: left; float: left; padding-top: 0px;">
    <span style="float: left;"><span class="btn btn-green brdrRadius3" (click)="closeModel()"
        style="line-height: 33px !important; padding: 0px 10px; font-size: 13px !important; color:#fff; background:#4caf50;"><i
          class="zmdi zmdi-check" aria-hidden="true" style="position: relative; top: 3px; font-size: 18px"></i> <span
          style="margin-left: 5px;">Apply</span></span></span>
  </div>

</ng-template>

<!--loding panel-->
<ngx-spinner color="rgb(232, 132, 33)" size="default" type="ball-clip-rotate">

</ngx-spinner>
